export default "__VITE_ASSET__D9GZoCRf__"